import { VisitApprovalInvalidation, VisitApprovalRoomSelector } from '../../planned.work/visit.approval/visit.approval.invalidation';
import { VisitApprovalProgressEvent } from '../../planned.work/visit.approval/visit.approval.progress';
import { RoomKey } from '../socket.room.key';

/**
 * Both envelopes ride these rooms: one busts caches, the other moves a single row's badge.
 *
 * The room key stays typed as the invalidation because that is what almost every consumer reads, and
 * widening it would force each of them to narrow before touching `payload.approvalId`. A consumer that
 * wants progress narrows to this union itself.
 */
export type VisitApprovalRoomEvent = VisitApprovalInvalidation | VisitApprovalProgressEvent;

/** Dedicated rooms: the socket gateway authorizes these before joining. Periods are never room keys. */
export const VisitApprovalRooms = {
    visitApprovalCustomer: (id: string): RoomKey<VisitApprovalInvalidation> => ({ key: `visit-approval:customer:${encodeURIComponent(id)}` }),
    visitApprovalSite: (id: string): RoomKey<VisitApprovalInvalidation> => ({ key: `visit-approval:site:${encodeURIComponent(id)}` }),
    visitApprovalServicePlan: (id: string): RoomKey<VisitApprovalInvalidation> => ({ key: `visit-approval:service-plan:${encodeURIComponent(id)}` }),
};

export function readVisitApprovalRoomScope(room: string): VisitApprovalRoomSelector | null {
    const match = /^visit-approval:(customer|site|service-plan):([^:]+)$/.exec(room);
    if (!match) return null;
    let id: string;
    try { id = decodeURIComponent(match[2]); } catch { return null; }
    if (!id || id.length > 200) return null;
    if (match[1] === 'customer') return { customerId: id };
    if (match[1] === 'site') return { siteId: id };
    return { servicePlanId: id };
}
